import React from "react";
import { Modal } from "../components";
import { Button } from "semantic-ui-react";
import { useApi } from "utilities/hookutils";
import { ButtonPrimary } from "components/Atoms/Button";
import { Loading } from "components/panels";

interface MapStateModalProps {
  alias: string
  country: server.dto.Countries
  handleClose: () => void
}

const MapStateModal = (props: MapStateModalProps) => {
  const [loading, setLoading] = React.useState(false);
  const [mappingState, setMappingState] = React.useState<server.dto.State | null>(null);

  const countryApi = useApi(
    async () => window.CoreApi.Country.GetCountry(props.country),
    [`StateAlias.ListUnmapped-${props.country}`]
  );

  const onCannotMap = () => {
    setLoading(true);
    window.CoreApi.StateAlias.SetCannotMap({ alias: props.alias, country: props.country }).then(() => {
      setLoading(false);
      props.handleClose();
    });
  };

  const onMap = (state: server.dto.State) => {
    setMappingState(state);
    window.CoreApi.StateAlias.SetStateId({
      alias: props.alias,
      country: props.country,
      stateId: state.key
    }).then(() => {
      setMappingState(null);
      props.handleClose();
    });
  };

  return <Modal
    isOpen={true}
    width="small"
    handleClose={props.handleClose}
    title={props.alias}
  >
    <div className="grow1 scrollbox-auto">
      {countryApi.isLoading && <Loading />}
      <div className="list striped">
        {countryApi.data?.data?.states.map((state) => (
          <div key={state.key} className="flex padding">
            <div style={{ flex: 1 }}>
              <span>{state.name}</span>
            </div>
            <ButtonPrimary
              loading={mappingState?.key === state.key}
              onClick={() => { onMap(state); }}
              label="map"
            />
          </div>
        ))}
      </div>
    </div>
    <div className="flex">
      <div className="grow1"></div>
      <div>
        <Button
          color="red"
          loading={loading}
          onClick={onCannotMap}
          content="Cannot map"
          name="Cannot map"
        />
      </div>
    </div>
  </Modal>;
};

export default MapStateModal;
